import { Injector } from '@angular/core';
import { Components } from '@formio/angular';
import { FormioCustomComponentInfo, registerExternalCustomFormioComponents } from '@pics-core/dynamic';
import { CustomSliderComponent } from './custom-slider.component';

const editForm = Components.components.number.editForm();

// Add custom configuration options for the slider
editForm.components[0].components.push({
  label: 'Slider Configuration',
  key: 'slider_configuration',
  components: [
    {
      label: 'Minimum Value',
      applyMaskOn: 'change',
      key: 'customOptions.min',
      type: 'number',
      input: true,
      defaultValue: 10,
      tableView: true
    },
    {
      label: 'Maximum Value',
      applyMaskOn: 'change',
      key: 'customOptions.max',
      type: 'number',
      input: true,
      defaultValue: 100,
      tableView: true
    },
    {
      label: 'Step',
      applyMaskOn: 'change',
      key: 'customOptions.step',
      type: 'number',
      input: true,
      defaultValue: 1,
      tableView: true
    },
    {
      label: 'Capped Value',
      applyMaskOn: 'change',
      key: 'customOptions.cappedValue',
      type: 'number',
      input: true,
      defaultValue: 90,
      tableView: true,
      tooltip: 'Maximum value that can be selected (if different from max)'
    },
    {
      html: '<p>Configure the professional development hours slider with calculation based on number of subjects.</p>',
      label: 'Content',
      customClass: 'mt-4 mb-4',
      refreshOnChange: false,
      key: 'content',
      type: 'content',
      input: false,
      tableView: false
    }
  ]
});

const COMPONENT_OPTIONS: FormioCustomComponentInfo = {
  type: 'customSlider',
  selector: 'app-custom-slider',
  group: 'advanced',
  title: 'Professional Development Hours Slider',
  icon: 'sliders-h',
  fieldOptions: ['value', 'form', 'description', 'disabled', 'name'],
  editForm: () => editForm,
  changeEvent: 'valueChange'
};

export function registerCustomSliderComponent(injector: Injector) {
  try {
    registerExternalCustomFormioComponents(COMPONENT_OPTIONS, CustomSliderComponent, injector);
    console.log('Custom Slider Component Registration Done');
  } catch (error) {
    console.log('Error in register custom slider component:', error);
  }
}
